// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2gCpq","options":"AnswerScale_options__2AjVk","selected":"AnswerScale_selected__1K0JZ"};